import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Icon from "@insite/mobius/Icon";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setRequestQuoteFormIsLoaded from "@MasterBluePrint/Store/Components/RequestQuoteModal/Handlers/SetRequestQuoteFormIsLoaded";
import setRequestQuoteModalIsOpen from "@MasterBluePrint/Store/Components/RequestQuoteModal/Handlers/SetRequestQuoteModalIsOpen";
import { MasterState } from "@MasterBluePrint/Store/MasterState";
import React, { useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: RequestQuoteModalStyles;
    formId?: string; 
    // onChanged: () => void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: MasterState) => {
    const { modalIsOpen, formIsLoaded, productNumber, paramThree, paramTwo, paramOne } =
        state.requestQuoteModal;
    return {
        modalIsOpen,
        formIsLoaded,
        productNumber,
        paramThree,
        paramTwo,
        paramOne,
    };
};

const mapDispatchToProps = {
    setRequestQuoteModalIsOpen,
    setRequestQuoteFormIsLoaded,
};

export interface RequestQuoteModalStyles {
    requestQuoteMainContainer?: InjectableCss;
    requestQuoteModal?: InjectableCss;
    requestQuoteHeading?: InjectableCss;
    requestQuoteLink?: InjectableCss;
    closeContainer?: InjectableCss;
    cancelButton?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export function GrabInnerHtml(
    parameterOne: string | undefined,
    parameterTwo: string | undefined,
    parameterThree: string | undefined,
    productNumberParameter: string | undefined,
) {
    const InnerHTML = `MktoForms2.loadForm("${parameterOne}", "${parameterTwo}", "${parameterThree}");
                     MktoForms2.whenReady(function(mktoForm){
                        const defaultValues = {
                            buy1Mod : "${productNumberParameter}",
                        };
                        let currentValues = mktoForm.getValues();
                        let finalValues = Object.keys(defaultValues)
                        .reduce(function(acc,key){
                            if( !currentValues[key] ) {
                                acc[key] = defaultValues[key];
                            }
                            return acc;
                        },{});
                        mktoForm.setValues(finalValues);
                    });
                    MktoForms2.whenReady(function(mktoForm){
                        document.getElementById("formLoadingSpinner").style.display = "none";
                    });`;

    return InnerHTML;
}

export const requestQuoteModalStyles: RequestQuoteModalStyles = {
    requestQuoteMainContainer: {
        css: css`
            background-color: #fff;
            font-weight: 600;
            font-size: 0.85rem;
            margin-bottom: 0.2em;
            margin-top: 0.9375rem;
            text-align: center;
            > div {
                background-color: #fff;
                box-shadow: 0 0 0px 10px #fff;
                padding: 0.625rem 0;
                justify-content: center;
            }
        `,
    },
    requestQuoteHeading: {
        css: css`
            color: #333f48;
            font-family: "Roboto", sans-serif;
            font-size: 1.25rem;
            font-weight: 500;
            letter-spacing: -0.024rem;
            line-height: 1.4375rem;
            margin-bottom: 0.31250625rem;
            width: 100%;
        `,
    },
    requestQuoteLink: {
        css: css`
            color: #333f48;
            font-family: Lato;
            font-size: 0.875rem;
            letter-spacing: 0;
            line-height: 1.5rem;
            text-decoration: underline;

            span {
                color: #333f48 !important;
            }
        `,
    },
    requestQuoteModal: {
        css: css`
            margin-top: 0;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            height: 100%;
            animation: 300ms ease 0s 1 normal none running fUZMVa;

            &.available-rent-modal {
                #modalTitle {
                    display: none;
                }

                @media screen and (min-width: 768px) {
                    > div {
                        height: auto;
                        max-height: calc(100% - 90px);
                        margin: 2.8125rem;
                        max-width: 31.25rem;
                        box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%),
                            0px 1px 18px 0px rgb(0 0 0 / 12%);
                        background: #fff;
                    }
                }
            }

            > div > div {
                position: relative;
            }

            > div > div > div {
                min-height: 170px;
            }

            form.mktoForm .mktoButtonRow {
                border-top: 1px solid rgba(215, 215, 215, 0.72);
                padding-top: 0.9375rem;
            }

            h1 {
                color: #333f48;
                font-family: "Roboto", sans-serif;
                font-size: 1.25rem;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 2rem;
                position: relative;
                margin-top: 1.5625rem;

                &:after {
                    height: 0.125rem;
                    width: 2.75rem;
                    background-color: #c63527;
                    content: "";
                    display: inline-block;
                    position: absolute;
                    bottom: -0.75rem;
                    left: 0.0625rem;
                }
            }

            form.mktoForm button.mktoButton {
                float: right;

                @media screen and (max-width: 767px) {
                    float: none;
                }
            }

            .mktoRequiredField .mktoAsterix {
                font-size: 0.9375rem !important;
                display: block !important;
                color: #535e64 !important;
            }

            .mktoLabel {
                color: #535e64 !important;
                font-family: "Roboto", sans-serif;
                font-size: 0.9375rem;
                font-weight: 500 !important;
                letter-spacing: 0.012rem;
                line-height: 1.4375rem;

                b,
                strong,
                span {
                    color: #535e64 !important;
                    font-family: "Roboto", sans-serif;
                    font-size: 0.9375rem;
                    font-weight: 500 !important;
                    letter-spacing: 0.012rem;
                }

                em {
                    // display: none !important;
                    padding-left: 0;
                    padding-right: 0;
                }
            }

            .mktoFormCol {
                margin-bottom: 0.625rem !important;
            }

            form.mktoForm .mktoRadioList label[for],
            form.mktoForm .mktoCheckboxList label[for] {
                padding: 0 0 0.9em 1.75em !important;
            }

            form {
                padding: 35px 0 20px 0;

                &.mktoForm {
                    padding: 35px 0 20px 0;
                }
            }

            form.mktoForm input[type="url"],
            form.mktoForm input[type="text"],
            form.mktoForm input[type="date"],
            form.mktoForm input[type="tel"],
            form.mktoForm input[type="email"],
            form.mktoForm input[type="number"],
            form.mktoForm textarea.mktoField,
            form.mktoForm select.mktoField {
                height: 2.5rem;
                border: 1px solid #cecece;
                border-radius: 0.125rem;
                background-color: #fff;
                min-height: 2.5rem;
            }
        `,
    },
    cancelButton: {
        css: css`
            color: #002554;
            font-family: "Roboto", sans-serif;
            font-size: 0.9375rem;
            letter-spacing: 0;
            line-height: 1.3125rem;
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            margin-left: 3em;
            margin-right: 3em;
            justify-content: center;
            width: auto;
            position: absolute;
            bottom: 3.875rem;

            @media screen and (max-width: 767px) {
                position: static;
                margin: 0.9375rem auto 0;
            }
        `,
    },
    closeContainer: {
        css: css`
            cursor: pointer;
            position: absolute;
            right: 1.25rem;
            top: 1.5rem;
            .close-label {
                color: #535e64;
                font-family: "Roboto", sans-serif;
                font-size: 0.875rem;
                letter-spacing: 0.01rem;
                line-height: 1;
                display: inline-block;
                margin-right: 0.625rem;
                vertical-align: middle;
            }
            .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1.125rem;
                height: 1.125rem;
                svg {
                    height: 1.125rem;
                    width: 1.125rem;
                }
            }
        `,
    },
    spinner: {
        css: css`
            margin: 1.5rem auto;
            display: block;
        `,
    },
};

const RequestQuoteModal = ({
    modalIsOpen,
    formIsLoaded,
    setRequestQuoteModalIsOpen,
    setRequestQuoteFormIsLoaded,
    extendedStyles,
    productNumber,
    paramThree,
    paramTwo,
    paramOne,
    formId,
}: Props) => {
    const [styles] = useState(() => mergeToNew(requestQuoteModalStyles, extendedStyles));
    const innerHtmlText = useRef("");
    const marketoScriptId = "mktoForms";

    const modalCloseHandler = () => {
        // remove form tag by id
        const formTagToRemove = document.getElementById(`${formId}`);
        if (formTagToRemove) {
            formTagToRemove.parentNode?.removeChild(formTagToRemove);
        }

        const scriptTagToRemove = document.getElementById(`mktoForms_${formId}`);
        if (scriptTagToRemove) {
            scriptTagToRemove.parentNode?.removeChild(scriptTagToRemove);
        }

        setRequestQuoteModalIsOpen({ modalIsOpen: false });
        setRequestQuoteFormIsLoaded({ formIsLoaded: false });
    };

    innerHtmlText.current = GrabInnerHtml(paramOne, paramTwo, formId, productNumber);

    if (!modalIsOpen) {
        return null;
    }

    if (!document.getElementById(`mktoForms_${formId}`)) {
        if (document.getElementById(marketoScriptId)) {
            const scriptTag = document.createElement("script");
            scriptTag.id = `mktoForms_${formId}`;
            scriptTag.innerHTML = innerHtmlText.current;

            document.body.appendChild(scriptTag);

            setRequestQuoteFormIsLoaded({ formIsLoaded: true });
        }
    }

    if (!formIsLoaded || !modalIsOpen) {
        return null;
    }

    if (document.getElementById(`${formId}`)) {
        return null;
    }

    return (
        <div {...styles.requestQuoteMainContainer}>
            <Typography as="div">
                <Modal
                    isOpen={modalIsOpen}
                    handleClose={() => modalCloseHandler()}
                    data-test-selector="requestQuoteModal"
                    {...styles.requestQuoteModal}
                    className="available-rent-modal"
                >
                    <Typography as="div" onClick={modalCloseHandler} {...styles.closeContainer}>
                        <span className="close-label">Close</span>
                        <Icon className="icon-close" src="X" />
                    </Typography>
                    <div>
                        <h1>Request a Quote</h1>
                        {/* {!formIsLoaded && <LoadingSpinner {...styles.spinner} id="formLoadingSpinner" />} */}
                        <form id={`mktoForm_${formId}`}></form>
                    </div>
                </Modal>
            </Typography>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestQuoteModal);
